import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const ServiceSection2 = (props) => {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const res = await fetch('/api/services');
                const data = await res.json();
                setServices(Array.isArray(data) ? data : []);
            } catch (error) {
                console.error('Error fetching services:', error);
                setServices([]);
            } finally {
                setLoading(false);
            }
        };
        fetchServices();
    }, []);

    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-8 col-12">
                        <div className="section-title">
                            <span>Our Services</span>
                            <h2>How We Serve Our
                                <span>Community</span></h2>
                        </div>
                    </div>
                    <div className="col-lg-4 col-12">
                        <div className="all-Service-btn">
                            <Link onClick={ClickHandler} to="/service" className="theme-btn">All Services</Link>
                        </div>
                    </div>
                </div>
                <div className="bg-image">
                </div>
            </div>
            <div className="container">
                <div className="service-wrap">
                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '40px' }}>Loading services...</div>
                    ) : (
                        services.slice(0, 4).map((service, index) => (
                            <div className="item" key={service.id || index}>
                                <div className="visible-content">
                                    <div className="icon">
                                        <i className={service.icon}></i>
                                    </div>
                                    <div className="text">
                                        <h2><Link onClick={ClickHandler} to={`/service-single/${service.slug}`}>{service.title}</Link></h2>
                                    </div>
                                </div>
                                <div className="hover-content">
                                    <div className="text">
                                        <h2><Link onClick={ClickHandler} to={`/service-single/${service.slug}`}>{service.title}</Link></h2>
                                        <span>{service.subtitle}</span>
                                        <Link onClick={ClickHandler} to={`/service-single/${service.slug}`}>Read More<i className="flaticon-right-arrow-1"></i></Link>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </section>
    );
}

export default ServiceSection2;




